import React, { FC } from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import FormatMoney from "go-core/components/Formatters/FormatMoney";
import { ProductApi } from "../../../../../../../../services/Api/Organization/types";

interface Props {
	product: ProductApi;
}

const ProductSummaryCard: FC<Props> = ({ product }) => {
	const { t } = useTranslation();
	const measureType = t(`enums.products.measure_types.${product.measure_type}`);

	return (
		<Card className="product-item-summary-card">
			<Card.Body>
				<div className="card-body-item">
					<div className="item-info">
						<span className="label">{t("common.word.cost")}:</span>
						<span>{product?.cost_price_money ? FormatMoney(product.cost_price_money) : "-"}</span>
					</div>
				</div>
				<div className="card-body-item">
					<div className="item-info">
						<span className="label">{t("common.word.last_price")}:</span>
						<span>{product?.last_price_money ? FormatMoney(product.last_price_money) : "-"}</span>
					</div>
				</div>
				{product.type !== "PACKAGE" && (
					<>
						<div className="card-body-item">
							<div className="item-info">
								<span className="label">{t("common.word.in_stock")}:</span>
								<span>
									{product?.state?.in_stock_amount !== undefined
										? `${product?.state?.in_stock_amount} ${measureType}`
										: "-"}
								</span>
							</div>
						</div>
						<div className="card-body-item">
							<div className="item-info">
								<span className="label">{t("common.word.committed_amount")}:</span>
								<span>
									{product?.state?.commited_amount !== undefined
										? `${product?.state?.commited_amount} ${measureType}`
										: "-"}
								</span>
							</div>
						</div>
						<div className="card-body-item">
							<div className="item-info">
								<span className="label">{t("common.word.incoming_amount")}:</span>
								<span>
									{product?.state?.incoming_amount !== undefined
										? `${product?.state?.incoming_amount} ${measureType}`
										: "-"}
								</span>
							</div>
						</div>
					</>
				)}
			</Card.Body>
		</Card>
	);
};

export default ProductSummaryCard;
